import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { Toaster } from 'sonner';
import { queryClient } from './lib/queryClient';
import { routeTree } from './routeTree.gen';
import { installVersionWatcher } from './lib/appVersion';
import './i18n';
import './styles/index.css';

const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  defaultStaleTime: 30_000,
  context: { queryClient },
  scrollRestoration: true,
});

// A tab opened before a deploy picks up the new build on its next page change.
installVersionWatcher(router);

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found');

import { ConfirmProvider } from '@/components/ui/confirm';
import { LocaleDirectionProvider } from '@/components/LocaleDirectionProvider';

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <LocaleDirectionProvider>
        <ConfirmProvider>
          <RouterProvider router={router} />
          <Toaster richColors closeButton position="top-right" />
        </ConfirmProvider>
      </LocaleDirectionProvider>
    </QueryClientProvider>
  </StrictMode>,
);
